/* Auryaa craft story: swap the sticky image as each step reaches the middle of the screen. */
class AuryaaCraftStory extends HTMLElement {
  connectedCallback() {
    this.steps = Array.from(this.querySelectorAll('[data-au-craft-step]'));
    this.images = Array.from(this.querySelectorAll('[data-au-craft-image]'));
    this.counter = this.querySelector('[data-au-craft-counter]');
    if (!this.steps.length) return;
    const start = () => this.observe();
    if (window.AuryaaMotion) start();
    else document.addEventListener('au:motion-ready', start, { once: true });
  }

  observe() {
    const gsap = window.AuryaaMotion && window.AuryaaMotion.gsap;
    const ScrollTrigger = window.ScrollTrigger;
    if (gsap && ScrollTrigger) {
      this.steps.forEach((step, i) => {
        ScrollTrigger.create({
          trigger: step,
          start: 'top 55%',
          end: 'bottom 55%',
          onEnter: () => this.activate(i),
          onEnterBack: () => this.activate(i)
        });
      });
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) this.activate(this.steps.indexOf(e.target)); });
    }, { rootMargin: '-45% 0px -45% 0px' });
    this.steps.forEach((s) => io.observe(s));
  }

  activate(i) {
    this.steps.forEach((s, k) => s.classList.toggle('is-active', k === i));
    this.images.forEach((img, k) => img.classList.toggle('is-active', k === i));
    if (this.counter) this.counter.textContent = String(i + 1).padStart(2, '0');
  }
}

if (!customElements.get('auryaa-craft-story')) customElements.define('auryaa-craft-story', AuryaaCraftStory);
